import { createI18n } from 'vue-i18n'

const messages = {
    es: {
        nav: {
            home: 'Inicio',
            services: 'Servicios',
            web: 'Diseño Webs',
            ads: 'Publicidad Digital',
            premium: 'Servicios Premium',
            contact: 'Contáctanos',
            about: 'Sobre Nosotros'
        },
        nav2: {
            home: 'Inicio',
            services: 'Servicios',
            web: 'Diseño Webs',
            ads: 'Publicidad Digital',
            contact: 'Contáctanos',
            about: 'Sobre Nosotros'
        },

        banner: {
            start: 'Comenzar',
            about: 'Conócenos',
            support: 'Atención al cliente',
            whatsapp: 'Chatea por WhatsApp',
            schedule: 'Horario de atención:',
            hours: 'Lunes a Viernes — 09:00 a 20:00',
            contact: 'Contáctanos',

            slide1: {
                sub: 'Bienvenido a Creativa360',
                title: 'De la idea al cliente, en 360º'
            },
            slide2: {
                sub: 'Bienvenido a Creativa360',
                title: 'Creamos páginas web que convierten visitas en clientes'
            },
            slide3: {
                sub: 'Bienvenido a Creativa360',
                title: 'Más que una web, una herramienta para hacer crecer tu empresa'
            }
        },
        banner2: {
            title: 'Políticas y Condiciones de Creativa360',
            desc: 'En Creativa360, nos comprometemos a ofrecer soluciones digitales con transparencia, responsabilidad y cercanía. Aquí encontrarás toda la información sobre nuestras políticas de servicio, privacidad y garantías, para que sepas cómo gestionamos tus proyectos, protegemos tus datos y aseguramos la calidad en cada desarrollo web y campaña publicitaria.',
            btn1: 'Ver políticas',
            btn2: 'Contactar soporte'
        },
        aboutPage: {
            section: {
                subTitle: 'TODO SOBRE NOSOTROS',
                heading: 'Nuestras políticas y condiciones'
            }
        },

        counter: {
            years: {
                line1: 'AÑOS DE',
                line2: 'EXPERIENCIA DIGITAL'
            },
            projects: {
                line1: 'PROYECTOS WEB',
                line2: 'ENTREGADOS'
            },
            clients: {
                line1: 'CLIENTES',
                line2: 'SATISFECHOS'
            },
            marketing: {
                line1: 'CAMPAÑAS Y SERVICIOS',
                line2: 'DE MARKETING'
            }
        },

        services: {
            why: {
                title: '¿POR QUÉ ELEGIRNOS?',
                heading: 'Soluciones digitales diseñadas para hacer crecer tu negocio',
                desc: 'En Creativa360 ayudamos a empresas a destacar y crecer con soluciones digitales pensadas para atraer clientes y generar resultados. Combinamos diseño web, estrategia y marketing para que tu negocio tenga una presencia sólida, profesional y orientada a conversión. Contamos con expertos en desarrollo de soluciones digitales que te acompañan en todo el proceso, adaptándonos a lo que realmente necesitas.'
            },

            card1: {
                title: 'Diseño web enfocado en resultados',
                desc: 'Creamos páginas web pensadas para atraer clientes, comunicar tu valor y convertir visitas en oportunidades reales. Cada proyecto está diseñado para ofrecer una experiencia clara, profesional y alineada con los objetivos de tu negocio.'
            },

            card2: {
                title: 'Soluciones digitales 360º para tu negocio',
                desc: 'No solo diseñamos webs, desarrollamos soluciones completas adaptadas a cada empresa. Te asesoramos en estrategia, contenido y presencia digital para que tu negocio tenga coherencia, visibilidad y crecimiento sostenido.'
            },

            card3: {
                title: 'Acompañamiento experto y cercano',
                desc: 'Nuestro equipo de expertos en soluciones digitales te acompaña en cada paso, ofreciéndote asesoramiento real y personalizado. Trabajamos contigo para entender tu negocio y construir una solución que realmente funcione y te ayude a crecer.'
            },

            cta: 'ME INTERESA!'
        },
        ceo: {
            badge: 'Director de Marketing y Estrategia Digital',
            summary: 'Cofundador y Director de Marketing de Creativa360, especializado en el desarrollo de estrategias y soluciones digitales orientadas a resultados. Acompaña a cada cliente como asesor, analizando su negocio y diseñando la mejor estrategia para atraer clientes, mejorar su presencia online y hacer crecer su empresa. Su enfoque combina visión estratégica, conocimiento del mercado y una orientación total a resultados.',
            show: 'Ver trayectoria completa',
            hide: 'Ocultar trayectoria',

            exp1: {
                role: 'Project Manager & Print Manager',
                company: 'Grafic Planet',
                date: 'ene. 2011 – feb. 2013 · 2 años 2 meses',
                location: 'Madrid',
                d1: 'Gestión integral de producción y supervisión técnica de maquinaria industrial de impresión digital.',
                d2: 'Coordinación de equipos de trabajo, planificación de tareas y control de calidad de impresión.',
                d3: 'Responsable de la ejecución de campañas publicitarias nacionales e internacionales para Movistar, Repsol, Nautalia, Vodafone y El Corte Inglés.',
                d4: 'Supervisión del mantenimiento preventivo y correctivo de impresoras de gran formato HP y Vutek.',
                d5: 'Implantación de mejoras operativas para optimizar los tiempos de producción.'
            },

            exp2: {
                role: 'Field Service Engineer',
                company: 'Kodak Solution IPS',
                date: 'feb. 2007 – feb. 2009 · 2 años 1 mes',
                location: 'Valencia',
                d1: 'Instalación, calibración y mantenimiento de impresoras de alta producción VX5000 para Key S.A.',
                d2: 'Participación en el proyecto Versamark, con despliegue técnico de impresoras en entorno de gran volumen (más de 8M€ en equipos).',
                d3: 'Soporte técnico en sistemas de impresión continua responsables de la facturación nacional de Movistar.',
                d4: 'Colaboración con equipos internacionales de Kodak IPS (Suiza) en pruebas de desarrollo y actualizaciones técnicas.',
                d5: 'Formación avanzada recibida en cabezales 1 y 2 inch y sistemas IPS Versamark VX5000.'
            },

            exp3: {
                role: 'Field Service Engineer (Gran Formato)',
                company: 'Sumo Center Gráfico · Distribuidor oficial HP Large Format',
                date: 'nov. 2004 – ene. 2007 · 2 años 3 meses',
                location: 'Las Rozas de Madrid (Comunidad de Madrid)',
                d1: 'Instalación, soporte y reparación de impresoras HP de gran formato (series Scitex, TurboJet, DesignJet).',
                d2: 'Diagnóstico de averías críticas en hardware, firmware y sistemas de impresión.',
                d3: 'Responsable de mantenimiento técnico y asistencia postventa a clientes corporativos.',
                d4: 'Formación técnica en HP (Madrid, Las Rozas) sobre modelos HP 9000, servidores ProLine y calibración de sistemas RIP.'
            },

            exp4: {
                role: 'Print Manager',
                company: 'Codice Transfer Factory',
                date: 'oct. 2000 – nov. 2004 · 4 años 2 meses',
                location: 'Málaga',
                d1: 'Gestión completa de la producción y supervisión del parque de maquinaria de impresión digital.',
                d2: 'Formación y liderazgo de técnicos de impresión, tintas y mantenimiento mecánico.',
                d3: 'Responsable de testeo de hardware y software EFI Vutek Press Vu 200/600 y 320/400 para sistemas DSCV dinámicos.',
                d4: 'Diseño y producción de transferencias textiles y materiales promocionales para clientes como Telefónica Cabitel y Adidas.'
            },

            exp5: {
                role: 'Print Manager & Project Manager / I+D',
                company: 'Codice',
                date: '2004 – (continuidad interna posterior)',
                location: 'Málaga',
                d1: 'Liderazgo de proyectos de innovación en impresión digital y materiales.',
                d2: 'Participación directa con EFI y Vutek en validaciones de hardware de gran formato y desarrollo de perfiles ICC.',
                d3: 'Gestión técnica de mantenimiento y producción de gran formato a nivel nacional.',
                d4: 'Colaboración en la integración de sistemas RIP, software EFI y calibraciones avanzadas.'
            },

            exp6: {
                role: 'Graphic Designer',
                company: 'Codice',
                date: 'sept. 1999 – oct. 2000 · 1 año 2 meses',
                location: 'Málaga',
                d1: 'Diseño gráfico especializado en transferencias y separaciones de color.',
                d2: 'Desarrollo visual para campañas promocionales y soportes publicitarios.',
                d3: 'Apoyo técnico en la preparación de archivos para impresión textil y gran formato.'
            },

            exp7: {
                role: 'Project Manager',
                company: 'Codice',
                date: 'sept. 1999 – nov. 2000 · 1 año 3 meses',
                location: 'Málaga, España',
                d1: 'Dirección y seguimiento del proyecto nacional Amplia’s (Grupo Wide Boyacá).',
                d2: 'Supervisión de implantación técnica y control de calidad en nuevos centros de impresión.',
                d3: 'Gestión de cronogramas de entrega, coordinación de proveedores y validación de resultados finales.'
            },

            exp8: {
                role: 'Rotating Machinery Operator',
                company: 'Avery Dennison',
                date: 'oct. 1996 – nov. 1997 · 1 año 2 meses',
                location: 'Maidenhead, Reino Unido',
                d1: 'Operador de maquinaria rotativa industrial para producción de etiquetas.',
                d2: 'Mantenimiento preventivo y limpieza técnica de sistemas mecánicos de alta velocidad.',
                d3: 'Apoyo al ingeniero de máquina en ajustes y calibraciones de línea.'
            },

            exp9: {
                role: 'Certificaciones y formación técnica destacada',
                company: 'Internacional (HP, Vutek, Kodak, Academia 3D Radical)',
                date: '1999 – 2007',
                location: 'España, Bélgica, Suiza e Israel',
                d1: 'Máster en XSI Softimage (Modelado 3D, Render, Animación y Combustión) – Academia 3D Radical, Málaga.',
                d2: 'Máster en Robótica Industrial y PLC – Universidad de Zaragoza.',
                d3: 'Curso HP 9000 y servidores ProLine en HP La Rozas (Madrid).',
                d4: 'Formación internacional en EFI Vutek Bruselas: tintas UV, cabezales, calibraciones y mantenimiento de sistemas PressVu.',
                d5: 'Curso Kodak Versamark VX 5000 IPS y Cabezales 1/2 inch – Centro Kodak Suiza.',
                d6: 'Curso HP Scitex en Netanya (Israel) de 3 semanas en desarrollo de impresión gran formato.',
                d7: 'FP en Electromecánica – FP Fuengirola (3 años).'
            }
        },
        about: {
            cta: 'Comenzar',

            card1: {
                title: 'Soluciones que hacen crecer tu negocio',
                desc: 'En Creativa360 no solo diseñamos páginas web, creamos soluciones digitales pensadas para atraer clientes y generar resultados. Analizamos tu negocio, entendemos tus objetivos y desarrollamos una estrategia que te permita destacar, posicionarte y crecer en el entorno digital.'
            },

            card2: {
                title: 'Invierte en crecimiento, no en una web',
                desc: 'Tu presencia digital debe trabajar para ti. Por eso desarrollamos soluciones enfocadas en generar visibilidad, oportunidades y clientes reales. Te ayudamos a convertir tu web en una herramienta estratégica que impulse tu negocio y te diferencie de tu competencia.'
            },

            card3: {
                title: 'Expertos que te acompañan en cada paso',
                desc: 'Nuestro equipo de expertos en soluciones digitales actúa como asesor para tu negocio, guiándote en cada decisión para maximizar resultados. No solo ejecutamos, te ayudamos a entender y aprovechar todo el potencial del entorno digital para hacer crecer tu empresa.'
            }
        },
        packs: {
            cta: 'Solicita información',

            basic: {
                name: 'Web para Empezar',
                title: 'Pack Web Esencial',
                desc: 'La opción ideal para empezar a atraer clientes y tener una presencia profesional desde el primer momento.',
                l1: 'Landing page enfocada en captar clientes y generar contactos.',
                l2: 'Estructura clara para comunicar tu negocio de forma efectiva.',
                l3: 'Integración directa con WhatsApp y formularios.',
                l4: 'Diseño adaptado a todos los dispositivos.',
                l5: 'Base optimizada para posicionamiento en Google.',
                l6: 'Pensada para empezar a generar oportunidades.'
            },

            pro: {
                name: 'Web para Crecer',
                title: 'Pack Web Profesional',
                desc: 'Para empresas que quieren convertir su web en una herramienta real de crecimiento.',
                l1: 'Web completa orientada a conversión.',
                l2: 'Estrategia enfocada en captar clientes.',
                l3: 'Asesoramiento personalizado.',
                l4: 'Optimización SEO inicial.',
                l5: 'Integraciones con herramientas clave.',
                l6: 'Enfocada en generar oportunidades reales.'
            },

            custom: {
                name: 'Web a Medida',
                title: 'Solución Digital Personalizada',
                desc: 'Para negocios que necesitan una solución más personal, fijamos un techo económico para usted.',
                l1: 'Desarrollo a medida.',
                l2: 'Funcionalidades avanzadas.',
                l3: 'Consultoría estratégica completa.',
                l4: 'Arquitectura escalable.',
                l5: 'Diseño exclusivo.',
                l6: 'Enfoque total en resultados.'
            }
        },
        homepage: {
            webpack: {
                subTitle: 'SOLUCIONES DIGITALES PARA IMPULSAR TU NEGOCIO',
                heading: 'Paquetes de Diseño Web a Medida'
            },

            app: {
                subTitle: 'DESCARGAR NUESTRA APP',
                heading: '¡Comercia desde cualquier parte del mundo!'
            }
        },
        premium: {
            subTitle: 'Servicios premium',
            title: 'Experiencias exclusivas para empresas',
            desc: 'Accede a espacios exclusivos, proveedores premium y condiciones especiales sin pagar de más. Nosotros tenemos los contactos, tú disfrutas del resultado.',
            cta: 'Solicitar evento',

            services: {
                s1: {
                    title: 'Catering corporativo',
                    text: 'Organizamos comidas y cenas de empresa en espacios exclusivos, con menús personalizados y proveedores de alta gama. Gracias a nuestros contactos, accedes a opciones premium a precios altamente competitivos.'
                },
                s2: {
                    title: 'Eventos de empresa',
                    text: 'Diseñamos eventos completos en ubicaciones elegantes y cuidadosamente seleccionadas. Nos encargamos de todo el proceso para que tu empresa proyecte una imagen profesional y diferencial.'
                },
                s3: {
                    title: 'Experiencias gastronómicas',
                    text: 'Creamos experiencias únicas como catas privadas, showcooking o eventos temáticos en entornos exclusivos. Todo gestionado con proveedores de confianza y condiciones especiales.'
                },
                s4: {
                    title: 'Eventos a medida',
                    text: 'Adaptamos cada evento a tu marca, tus objetivos y tu equipo. Desde reuniones íntimas hasta grandes celebraciones en espacios premium cuidadosamente seleccionados.'
                },
                s5: {
                    title: 'Gestión integral',
                    text: 'Nos encargamos absolutamente de todo: planificación, proveedores, coordinación y ejecución. Tú solo disfrutas del evento mientras nosotros gestionamos cada detalle.'
                },
                s6: {
                    title: 'Experiencia premium',
                    text: 'Trabajamos con una red de contactos que nos permite ofrecerte los mejores espacios, servicios y condiciones del mercado, garantizando calidad, exclusividad y precios inigualables.'
                }
            }
        },
        ads: {
            subTitle: 'Publicidad digital y exterior',
            title: 'Impulsa tu negocio con campañas estratégicas y presencia visual',
            desc: `Creamos, gestionamos y optimizamos campañas publicitarias en Google, Meta y otras plataformas
  para aumentar tu visibilidad, atraer clientes y maximizar tu retorno de inversión.  
  Además, ofrecemos vinilado profesional de vehículos y publicidad exterior para que tu marca se vea tanto en el mundo digital como en la calle.`,

            conditionsTitle: 'Condiciones del servicio',
            ctaCall: 'Hablar ahora',
            ctaQuote: 'Solicitar propuesta',

            benefits: {
                b1: {
                    title: 'Estrategias orientadas a resultados',
                    text: 'Campañas diseñadas para atraer clientes reales y aumentar conversiones.'
                },
                b2: {
                    title: 'Optimización continua',
                    text: 'Ajustes semanales para mejorar rendimiento y reducir costes por clic.'
                },
                b3: {
                    title: 'Presencia multicanal',
                    text: 'Google Ads, Meta Ads, TikTok Ads y más para llegar a tu audiencia ideal.'
                },
                b4: {
                    title: 'Acompañamiento experto',
                    text: 'Informes claros, asesoría constante y soporte personalizado.'
                },
                b5: {
                    title: 'Vinilado de vehículos',
                    text: 'Transforma tu coche o furgoneta en una valla publicitaria móvil con vinilos de alta calidad.'
                },
                b6: {
                    title: 'Publicidad exterior',
                    text: 'Carteles, mupis, rótulos y soportes urbanos para que tu marca esté presente en zonas clave.'
                }
            },

            conditions: {
                c1: {
                    title: '1. Alcance del servicio',
                    text: `
        El servicio incluye la <b>creación, gestión y optimización</b> de campañas publicitarias en plataformas como Google Ads,
        Meta Ads (Facebook/Instagram), TikTok Ads y otras según el plan contratado. <br><br>
        También ofrecemos <b>vinilado profesional de vehículos</b> y <b>publicidad exterior</b> en soportes físicos como carteles, rótulos y mupis. <br><br>
        Creativa360 se encarga de la <b>configuración técnica, segmentación, análisis y optimización</b> continua para mejorar
        el rendimiento de las campañas.
      `
                },

                c2: {
                    title: '2. Gestión y optimización',
                    text: `
        <ul>
          <li><b>Optimización semanal:</b> ajustes de pujas, segmentación, anuncios y palabras clave.</li>
          <li><b>Informes mensuales:</b> métricas claras sobre clics, conversiones, alcance y coste por resultado.</li>
          <li><b>Revisión de estrategia:</b> análisis de rendimiento y propuestas de mejora continuas.</li>
          <li><b>No incluye:</b> inversión publicitaria (budget), que será abonada directamente a la plataforma.</li>
        </ul>
      `
                },

                c3: {
                    title: '3. Plataformas y cobertura',
                    text: `
        La gestión puede realizarse en una o varias plataformas según el plan contratado:
        <b>Google Ads, Facebook/Instagram Ads, TikTok Ads, YouTube Ads</b> y otras. <br><br>
        Creativa360 podrá recomendar cambios de plataforma o estrategia si detecta oportunidades de mejora.
      `
                },

                c4: {
                    title: '4. Condiciones económicas y facturación',
                    text: `
        La cuota del servicio es <b>mensual</b> y cubre la gestión profesional de las campañas.  
        La inversión publicitaria se paga por separado directamente a la plataforma. <br><br>
        Los servicios de vinilado y publicidad exterior se presupuestan por separado según necesidades específicas.  
        La falta de pago suspenderá la gestión hasta regularización. 
        Los precios no incluyen impuestos y podrán actualizarse anualmente previo aviso.
      `
                },

                c5: {
                    title: '5. Garantía y exclusiones',
                    text: `
        Creativa360 garantiza la <b>gestión profesional</b> de las campañas, pero no puede asegurar resultados específicos,
        ya que dependen del mercado, competencia, presupuesto y comportamiento del usuario. <br><br>
        Quedan excluidos:
        <ul>
          <li>Campañas creadas por terceros sin supervisión de Creativa360.</li>
          <li>Problemas derivados de páginas web lentas, sin SEO o con errores técnicos.</li>
          <li>Limitaciones impuestas por las plataformas publicitarias.</li>
          <li>Daños o alteraciones en vinilos por causas externas (clima, accidentes, mal uso).</li>
        </ul>
      `
                }
            }
        },
        contactForm: {
            title: '¿Tienes una consulta?',
            subtitle: 'Déjanos tus datos y te contactamos en breve.',

            name: 'Nombre y apellido *',
            company: 'Empresa (opcional)',
            phone: 'Teléfono *',
            email: 'Email *',
            message: '¿En qué podemos ayudarte?',

            submit: 'Enviar solicitud',
            sending: 'Enviando...',

            success: '✅ Gracias. Te contactamos en breve.',
            error: '❌ Hubo un problema al enviar. Inténtalo más tarde.'
        },

        footer: {
            company: 'Creativa360.es',
            location: 'Mijas Costa | Málaga',

            about: 'Sobre nosotros',
            contact: 'Contacto',
            policies: 'Políticas de empresa',

            location2: 'Base en Málaga · Servicio en toda España',
            support: 'Soporte remoto y desplazamiento in situ',

            services: {
                web: 'Diseño y desarrollo web',
                ads: 'Publicidad digital (Google, Meta, TikTok)',
                seo: 'SEO y posicionamiento orgánico',
                social: 'Gestión de redes sociales',
                branding: 'Branding e identidad visual',
                cta: 'Solicitar presupuesto'
            },

            policy: {
                privacy: 'Política de privacidad',
                cookies: 'Política de cookies',
                legal: 'Aviso legal',
                terms: 'Condiciones del servicio'
            }
        },
        legalTabs: {
            cta: 'COMPRAR / PEDIR',

            privacy: {
                name: 'Privacidad',
                title: 'Política de privacidad y tratamiento de datos',
                desc: 'En Creativa360 tratamos los datos de nuestros clientes con total confidencialidad. Utilizamos tu información únicamente para gestionar proyectos, ofrecer soporte y mejorar nuestros servicios de marketing.',
                l1: 'Recogemos datos como nombre, email, teléfono y detalles del proyecto para poder prestarte el servicio contratado.',
                l2: 'No vendemos ni cedemos tu información a terceros con fines comerciales.',
                l3: 'Usamos tus datos para gestionar campañas, crear webs, enviar presupuestos y ofrecer soporte.',
                l4: 'Puedes solicitar modificación o eliminación de tus datos escribiendo a nuestro email'
            },

            guarantee: {
                name: 'Garantía',
                title: 'Garantía de servicio y condiciones de responsabilidad',
                desc: 'Trabajamos con transparencia y profesionalidad. Te explicamos qué cubre nuestra garantía en servicios digitales y qué aspectos dependen de factores externos.',
                l1: 'La garantía cubre errores técnicos derivados del desarrollo web, configuraciones de campañas o entregables realizados por Creativa360.',
                l2: 'Modificaciones realizadas por terceros pueden anular la garantía del proyecto.',
                l3: 'No asumimos responsabilidad por pérdidas económicas derivadas de cambios en algoritmos, políticas de plataformas o factores externos.',
                l4: 'Ofrecemos soporte prioritario en proyectos activos para garantizar continuidad y resultados.'
            },

            support: {
                name: 'Soporte',
                title: 'Atención al cliente y soporte en marketing digital',
                desc: 'Acompañamos a nuestros clientes durante todo el proceso. Ofrecemos soporte en campañas, webs, redes sociales y cualquier servicio contratado.',
                l1: 'Soporte para campañas de publicidad, webs, SEO y redes sociales.',
                l2: 'Asistencia por teléfono, email o videollamada para resolver dudas o incidencias.',
                l3: 'Actualizaciones, ajustes y optimizaciones continuas según el servicio contratado.',
                l4: 'Contacto directo: +34 623 61 51 28 · '
            }
        }
    },

    en: {
        nav: {
            home: 'Home',
            services: 'Services',
            web: 'Web Design',
            ads: 'Digital Advertising',
            premium: 'Premium Services',
            contact: 'Contact Us',
            about: 'About Us'
        },
        nav2: {
            home: 'Home',
            services: 'Services',
            web: 'Web Design',
            ads: 'Digital Advertising',
            contact: 'Contact Us',
            about: 'About Us'
        },

        banner: {
            start: 'Get Started',
            about: 'About Us',
            support: 'Customer Support',
            whatsapp: 'Chat on WhatsApp',
            schedule: 'Working Hours:',
            hours: 'Monday to Friday — 09:00 to 20:00',
            contact: 'Contact Us',

            slide1: {
                sub: 'Welcome to Creativa360',
                title: 'From idea to customer, 360º'
            },
            slide2: {
                sub: 'Welcome to Creativa360',
                title: 'We create websites that convert visitors into clients'
            },
            slide3: {
                sub: 'Welcome to Creativa360',
                title: 'More than a website, a tool to grow your business'
            }
        },
        banner2: {
            title: 'Creativa360 Policies and Terms',
            desc: 'At Creativa360, we are committed to delivering digital solutions with transparency, responsibility, and a close approach. Here you will find all the information about our service policies, privacy, and guarantees, so you understand how we manage your projects, protect your data, and ensure quality in every web development and advertising campaign.',
            btn1: 'View policies',
            btn2: 'Contact support'
        },
        premium: {
            subTitle: 'Premium services',
            title: 'Exclusive experiences for companies',
            desc: 'Access exclusive venues, premium suppliers and special conditions without overpaying. We handle the connections, you enjoy the results.',
            cta: 'Request event',

            services: {
                s1: {
                    title: 'Corporate catering',
                    text: 'We organize corporate lunches and dinners in exclusive venues, with tailored menus and high-end suppliers. Thanks to our network, you get premium options at highly competitive prices.'
                },
                s2: {
                    title: 'Corporate events',
                    text: 'We design full-scale events in carefully selected, elegant locations. We handle everything so your company projects a strong and professional image.'
                },
                s3: {
                    title: 'Gastronomic experiences',
                    text: 'We create unique experiences such as private tastings, showcooking, and themed events in exclusive settings, all managed with trusted suppliers and special conditions.'
                },
                s4: {
                    title: 'Custom events',
                    text: 'Each event is tailored to your brand, goals and team. From intimate meetings to large-scale celebrations in premium, carefully selected venues.'
                },
                s5: {
                    title: 'Full management',
                    text: 'We take care of everything: planning, suppliers, coordination and execution. You simply enjoy the event while we handle every detail.'
                },
                s6: {
                    title: 'Premium experience',
                    text: 'Our network gives you access to the best venues and services on the market, ensuring quality, exclusivity and unmatched conditions.'
                }
            }
        },

        counter: {
            years: {
                line1: 'YEARS OF',
                line2: 'DIGITAL EXPERIENCE'
            },
            projects: {
                line1: 'WEB PROJECTS',
                line2: 'DELIVERED'
            },
            clients: {
                line1: 'SATISFIED',
                line2: 'CLIENTS'
            },
            marketing: {
                line1: 'MARKETING CAMPAIGNS',
                line2: 'AND SERVICES'
            }
        },
        aboutPage: {
            section: {
                subTitle: 'ALL ABOUT US',
                heading: 'Our policies and terms'
            }
        },

        services: {
            why: {
                title: 'WHY CHOOSE US?',
                heading: 'Digital solutions designed to grow your business',
                desc: 'At Creativa360, we help businesses stand out and grow through digital solutions designed to attract clients and generate results. We combine web design, strategy, and marketing to build a strong, professional, and conversion-focused presence. Our experts guide you throughout the entire process, adapting everything to your real needs.'
            },

            card1: {
                title: 'Results-driven web design',
                desc: 'We create websites designed to attract clients, communicate your value, and turn visits into real opportunities. Every project is built to deliver a clear, professional experience aligned with your business goals.'
            },

            card2: {
                title: '360º digital solutions for your business',
                desc: 'We don’t just design websites—we build complete digital solutions tailored to each business. We guide you in strategy, content, and online presence so your brand achieves consistency, visibility, and sustainable growth.'
            },

            card3: {
                title: 'Expert and close support',
                desc: 'Our team of digital experts supports you every step of the way, providing real and personalized guidance. We work with you to understand your business and build a solution that truly works and helps you grow.'
            },

            cta: 'I’M INTERESTED'
        },
        ceo: {
            badge: 'Marketing Director & Digital Strategy',
            summary: 'Co-founder and Marketing Director at Creativa360, specialized in developing results-driven digital strategies and solutions. He works closely with each client as an advisor, analyzing their business and designing the best strategy to attract customers, improve their online presence, and grow their company. His approach combines strategic vision, market knowledge, and a strong results-oriented mindset.',
            show: 'View full career',
            hide: 'Hide career',

            exp1: {
                role: 'Project Manager & Print Manager',
                company: 'Grafic Planet',
                date: 'Jan 2011 – Feb 2013 · 2 years 2 months',
                location: 'Madrid',
                d1: 'End-to-end production management and technical supervision of industrial digital printing machinery.',
                d2: 'Team coordination, task planning, and print quality control.',
                d3: 'Responsible for executing national and international advertising campaigns for Movistar, Repsol, Nautalia, Vodafone, and El Corte Inglés.',
                d4: 'Supervision of preventive and corrective maintenance of HP and Vutek large format printers.',
                d5: 'Implementation of operational improvements to optimize production times.'
            },

            exp2: {
                role: 'Field Service Engineer',
                company: 'Kodak Solution IPS',
                date: 'Feb 2007 – Feb 2009 · 2 years 1 month',
                location: 'Valencia',
                d1: 'Installation, calibration, and maintenance of high-production VX5000 printers for Key S.A.',
                d2: 'Participation in the Versamark project, deploying printers in high-volume environments (over €8M in equipment).',
                d3: 'Technical support for continuous printing systems responsible for Movistar’s national billing.',
                d4: 'Collaboration with international Kodak IPS teams (Switzerland) in development testing and technical upgrades.',
                d5: 'Advanced training in 1 and 2-inch printheads and IPS Versamark VX5000 systems.'
            },

            exp3: {
                role: 'Field Service Engineer (Large Format)',
                company: 'Sumo Center Gráfico · Official HP Large Format Distributor',
                date: 'Nov 2004 – Jan 2007 · 2 years 3 months',
                location: 'Las Rozas de Madrid (Community of Madrid)',
                d1: 'Installation, support, and repair of HP large format printers (Scitex, TurboJet, DesignJet series).',
                d2: 'Diagnosis of critical failures in hardware, firmware, and printing systems.',
                d3: 'Responsible for technical maintenance and post-sales support for corporate clients.',
                d4: 'Technical training at HP (Madrid, Las Rozas) on HP 9000 models, ProLine servers, and RIP system calibration.'
            },

            exp4: {
                role: 'Print Manager',
                company: 'Codice Transfer Factory',
                date: 'Oct 2000 – Nov 2004 · 4 years 2 months',
                location: 'Málaga',
                d1: 'Full production management and supervision of digital printing machinery fleet.',
                d2: 'Training and leadership of technicians in printing, inks, and mechanical maintenance.',
                d3: 'Responsible for hardware and software testing of EFI Vutek Press Vu 200/600 and 320/400 for dynamic DSCV systems.',
                d4: 'Design and production of textile transfers and promotional materials for clients such as Telefónica Cabitel and Adidas.'
            },

            exp5: {
                role: 'Print Manager & Project Manager / R&D',
                company: 'Codice',
                date: '2004 – (internal continuity thereafter)',
                location: 'Málaga',
                d1: 'Leadership of innovation projects in digital printing and materials.',
                d2: 'Direct collaboration with EFI and Vutek in large format hardware validation and ICC profile development.',
                d3: 'Technical management of maintenance and large format production at a national level.',
                d4: 'Collaboration in the integration of RIP systems, EFI software, and advanced calibrations.'
            },

            exp6: {
                role: 'Graphic Designer',
                company: 'Codice',
                date: 'Sep 1999 – Oct 2000 · 1 year 2 months',
                location: 'Málaga',
                d1: 'Graphic design specialized in transfers and color separations.',
                d2: 'Visual development for promotional campaigns and advertising media.',
                d3: 'Technical support in file preparation for textile and large format printing.'
            },

            exp7: {
                role: 'Project Manager',
                company: 'Codice',
                date: 'Sep 1999 – Nov 2000 · 1 year 3 months',
                location: 'Málaga, Spain',
                d1: 'Management and monitoring of the national Amplia’s project (Grupo Wide Boyacá).',
                d2: 'Supervision of technical implementation and quality control in new printing centers.',
                d3: 'Management of delivery timelines, supplier coordination, and validation of final results.'
            },

            exp8: {
                role: 'Rotating Machinery Operator',
                company: 'Avery Dennison',
                date: 'Oct 1996 – Nov 1997 · 1 year 2 months',
                location: 'Maidenhead, United Kingdom',
                d1: 'Operator of industrial rotary machinery for label production.',
                d2: 'Preventive maintenance and technical cleaning of high-speed mechanical systems.',
                d3: 'Support to the machine engineer in line adjustments and calibrations.'
            },

            exp9: {
                role: 'Key Certifications & Technical Training',
                company: 'International (HP, Vutek, Kodak, Academia 3D Radical)',
                date: '1999 – 2007',
                location: 'Spain, Belgium, Switzerland, and Israel',
                d1: 'Master’s in XSI Softimage (3D Modeling, Rendering, Animation, and Combustion) – Academia 3D Radical, Málaga.',
                d2: 'Master’s in Industrial Robotics and PLC – University of Zaragoza.',
                d3: 'HP 9000 and ProLine servers course at HP Las Rozas (Madrid).',
                d4: 'International training at EFI Vutek Brussels: UV inks, printheads, calibration, and PressVu system maintenance.',
                d5: 'Kodak Versamark VX 5000 IPS and 1/2 inch printheads course – Kodak Center Switzerland.',
                d6: 'HP Scitex course in Netanya (Israel), 3-week large format printing development program.',
                d7: 'Vocational training in Electromechanics – FP Fuengirola (3 years).'
            }
        },
        about: {
            cta: 'Get Started',

            card1: {
                title: 'Solutions that grow your business',
                desc: 'At Creativa360, we don’t just design websites—we create digital solutions designed to attract clients and generate results. We analyze your business, understand your goals, and develop a strategy that helps you stand out, position yourself, and grow in the digital environment.'
            },

            card2: {
                title: 'Invest in growth, not just a website',
                desc: 'Your digital presence should work for you. That’s why we develop solutions focused on generating visibility, opportunities, and real clients. We help you turn your website into a strategic tool that drives your business forward and sets you apart from competitors.'
            },

            card3: {
                title: 'Experts guiding you every step of the way',
                desc: 'Our team of digital experts acts as an advisor for your business, guiding you in every decision to maximize results. We don’t just execute—we help you understand and leverage the full potential of the digital world to grow your company.'
            }
        },
        packs: {
            cta: 'Request Information',

            basic: {
                name: 'Starter Website',
                title: 'Essential Website Package',
                desc: 'The ideal option to start attracting clients with a professional online presence.',
                l1: 'Landing page designed to capture leads.',
                l2: 'Clear structure to communicate your business.',
                l3: 'WhatsApp and contact form integration.',
                l4: 'Responsive design for all devices.',
                l5: 'SEO-ready structure.',
                l6: 'Built to generate opportunities.'
            },

            pro: {
                name: 'Growth Website',
                title: 'Professional Website Package',
                desc: 'For businesses that want a website that truly drives growth.',
                l1: 'Conversion-focused website.',
                l2: 'Strategic design to attract clients.',
                l3: 'Personalized consulting included.',
                l4: 'Initial SEO optimization.',
                l5: 'Integration with key tools.',
                l6: 'Focused on generating real results.'
            },

            custom: {
                name: 'Custom Website',
                title: 'Custom Digital Solution',
                desc: 'For businesses that need a fully tailored solution.',
                l1: 'Fully custom development.',
                l2: 'Advanced features.',
                l3: 'Full strategic consulting.',
                l4: 'Scalable architecture.',
                l5: 'Unique design.',
                l6: 'Built for maximum results.'
            }
        },
        homepage: {
            webpack: {
                subTitle: 'DIGITAL SOLUTIONS TO BOOST YOUR BUSINESS',
                heading: 'Custom Web Design Packages'
            },

            app: {
                subTitle: 'DOWNLOAD OUR APP',
                heading: 'Sell from anywhere in the world!'
            }
        },
        ads: {
            subTitle: 'Digital and Outdoor Advertising',
            title: 'Boost your business with strategic campaigns and strong visual presence',
            desc: `We create, manage and optimize advertising campaigns on Google, Meta and other platforms
  to increase your visibility, attract customers and maximize your return on investment.  
  We also offer professional vehicle wrapping and outdoor advertising so your brand is visible both online and in the real world.`,

            conditionsTitle: 'Service Conditions',
            ctaCall: 'Talk now',
            ctaQuote: 'Request proposal',

            benefits: {
                b1: {
                    title: 'Results-driven strategies',
                    text: 'Campaigns designed to attract real customers and increase conversions.'
                },
                b2: {
                    title: 'Continuous optimization',
                    text: 'Weekly adjustments to improve performance and reduce cost per click.'
                },
                b3: {
                    title: 'Multichannel presence',
                    text: 'Google Ads, Meta Ads, TikTok Ads and more to reach your ideal audience.'
                },
                b4: {
                    title: 'Expert support',
                    text: 'Clear reports, ongoing consulting and personalized support.'
                },
                b5: {
                    title: 'Vehicle wrapping',
                    text: 'Turn your car or van into a mobile billboard with high-quality vinyl.'
                },
                b6: {
                    title: 'Outdoor advertising',
                    text: 'Billboards, street ads and signage to position your brand in key locations.'
                }
            },

            conditions: {
                c1: {
                    title: '1. Scope of service',
                    text: `
        The service includes <b>creation, management and optimization</b> of advertising campaigns on platforms such as Google Ads,
        Meta Ads (Facebook/Instagram), TikTok Ads and others depending on the selected plan. <br><br>
        We also offer <b>professional vehicle wrapping</b> and <b>outdoor advertising</b> on physical media such as billboards and signage. <br><br>
        Creativa360 handles <b>technical setup, segmentation, analysis and continuous optimization</b> to improve campaign performance.
      `
                },

                c2: {
                    title: '2. Management and optimization',
                    text: `
        <ul>
          <li><b>Weekly optimization:</b> adjustments of bids, targeting, ads and keywords.</li>
          <li><b>Monthly reports:</b> clear metrics on clicks, conversions, reach and cost per result.</li>
          <li><b>Strategy review:</b> performance analysis and continuous improvement proposals.</li>
          <li><b>Not included:</b> advertising budget, which is paid directly to the platform.</li>
        </ul>
      `
                },

                c3: {
                    title: '3. Platforms and coverage',
                    text: `
        Campaign management can be carried out on one or multiple platforms depending on the plan:
        <b>Google Ads, Facebook/Instagram Ads, TikTok Ads, YouTube Ads</b> and others. <br><br>
        Creativa360 may recommend platform or strategy changes if improvement opportunities are detected.
      `
                },

                c4: {
                    title: '4. Pricing and billing conditions',
                    text: `
        The service fee is <b>monthly</b> and covers professional campaign management.  
        The advertising budget is paid separately directly to the platform. <br><br>
        Vehicle wrapping and outdoor advertising services are quoted separately based on needs.  
        Non-payment will suspend the service until resolved.  
        Prices do not include taxes and may be updated annually with prior notice.
      `
                },

                c5: {
                    title: '5. Warranty and exclusions',
                    text: `
        Creativa360 guarantees <b>professional campaign management</b> but cannot ensure specific results,
        as they depend on market conditions, competition, budget and user behavior. <br><br>
        Excluded:
        <ul>
          <li>Campaigns created by third parties without Creativa360 supervision.</li>
          <li>Issues caused by slow, unoptimized or faulty websites.</li>
          <li>Limitations imposed by advertising platforms.</li>
          <li>Damage to vinyl due to external causes (weather, accidents, misuse).</li>
        </ul>
      `
                }
            }
        },
        contactForm: {
            title: 'Do you have a question?',
            subtitle: 'Leave your details and we will contact you shortly.',

            name: 'Full name *',
            company: 'Company (optional)',
            phone: 'Phone *',
            email: 'Email *',
            message: 'How can we help you?',

            submit: 'Send request',
            sending: 'Sending...',

            success: '✅ Thank you. We will contact you shortly.',
            error: '❌ There was an error sending your request. Please try again later.'
        },
        footer: {
            company: 'Creativa360.es',
            location: 'Mijas Costa | Málaga',

            about: 'About us',
            contact: 'Contact',
            policies: 'Company policies',

            location2: 'Based in Málaga · Service across Spain',
            support: 'Remote support and on-site service',

            services: {
                web: 'Web design & development',
                ads: 'Digital advertising (Google, Meta, TikTok)',
                seo: 'SEO & organic positioning',
                social: 'Social media management',
                branding: 'Branding & visual identity',
                cta: 'Request a quote'
            },

            policy: {
                privacy: 'Privacy policy',
                cookies: 'Cookie policy',
                legal: 'Legal notice',
                terms: 'Terms of service'
            }
        },
        legalTabs: {
            cta: 'BUY / ORDER',

            privacy: {
                name: 'Privacy',
                title: 'Privacy Policy and Data Processing',
                desc: 'At Creativa360, we handle client data with full confidentiality, using it only to manage projects, provide support and improve our services.',
                l1: 'We collect data such as name, email, phone and project details to deliver our services.',
                l2: 'We do not sell or share your data with third parties for commercial purposes.',
                l3: 'Your data is used for campaigns, websites, proposals and customer support.',
                l4: 'You can request modification or deletion of your data at us email'
            },

            guarantee: {
                name: 'Guarantee',
                title: 'Service Guarantee and Liability Conditions',
                desc: 'We work with transparency and professionalism, explaining what our service covers and what depends on external factors.',
                l1: 'Covers technical issues from web development and campaign setup by Creativa360.',
                l2: 'Third-party modifications may void the project guarantee.',
                l3: 'We are not responsible for external factors like algorithms or platform changes.',
                l4: 'We provide priority support to ensure continuity and performance.'
            },

            support: {
                name: 'Support',
                title: 'Customer Service and Digital Marketing Support',
                desc: 'We guide and support our clients throughout the entire process and all contracted services.',
                l1: 'Support for ads, websites, SEO and social media',
                l2: 'Assistance via phone, email or video call',
                l3: 'Ongoing updates, adjustments and optimizations.',
                l4: 'Direct contact: +34 623 61 51 28'
            }
        }

    }
}

export const i18n = createI18n({
    locale: localStorage.getItem('lang') || 'es',
    fallbackLocale: 'en',
    messages
})